import React, { useState, useEffect } from 'react';

// Material
import { Grid, Switch, FormControlLabel } from '@mui/material';
import Spinner from '../../../components/spinner';

// Hooks
import useNotify from '../../../hooks/notify';
import useUser from '../../../hooks/user/useUser';

// Components
import Dropdown from '../../../components/inputs/dropdown';

import BranchService from '../../../services/branchService';

const PrintModal = ({ ticket, setPrinter, loading, setIsTaxFree, isTaxFree }) => {
    const user = useUser();
    const { Notify, variants } = useNotify();
    const [printers, setPrinters] = useState([]);
    const [printerSelected, setPrinterSelected] = useState();

    useEffect(() => {
        BranchService.GetPrinters(user.branch.id)
            .then(res => {
                const withOutFiscal = res.filter(printer => printer.isFiscal === false)
                setPrinters(withOutFiscal);
            })
            .catch(() => Notify("Error al intentar obtener impresoras", variants.ERROR));
    }, [user.branch.id, Notify, variants.ERROR]);

    const handleSelectPrinter = async (printerId) => {
        setPrinterSelected(printerId);
        setPrinter(printerId);
    }

    const handleSwitchChange = async (event) => {
        setIsTaxFree(event.target.checked);
    }

    return (
        <Grid container direction='column' spacing={1}>
            <Grid>
                <Dropdown
                    fullWidth
                    size='small'
                    onChange={(event) => handleSelectPrinter(event.target.value)}
                    placeholder="Impresoras"
                    name='printers'
                    label="Impresoras"
                    helperText='Selecciona una impresora de la lista.'
                    getOptionLabel={(option) => option?.name}
                    getOptionValue={(option) => option?.id}
                    value={printerSelected || ""}
                    values={printers}
                    disabled={!printers.length}
                />
                {setIsTaxFree && user?.branch?.country === "UY" &&
                    <FormControlLabel
                        label="Tax Free"
                        control={<Switch
                            color='primary'
                            name='isTaxFree'
                            onChange={handleSwitchChange}
                            checked={isTaxFree}
                                 />}
                    />
                }
            </Grid>
            {
                loading &&
                <Grid>
                    <Spinner message='Obteniendo ticket' />
                </Grid>
            }
            {
                !loading && ticket &&
                <Grid>
                    <div dangerouslySetInnerHTML={{ __html: ticket }} />
                </Grid>
            }
        </Grid>
    );
}

export default PrintModal;